import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { rootRoute } from './root.tsx'

// Where a player corrects their own data and decides who reads it. Same roles as
// `/me/player`: a guardian opens it on the switcher's active child.
export const myPlayerEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.myPlayerEdit,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['player', 'parent'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/my-player-edit.tsx')),
})

/** Where a player edits their own profile. A constant so no page respells the path. */
export const myPlayerEditLink = { to: NAV_PATHS.myPlayerEdit } as const
